import * as React from 'react';
import ToastPopup from 'productpage/ToastPopup';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { useToast } from 'hooks/useToast';

type Props = {};
export const ToastWrapper = (props: Props) => {
  const loginInfo = useLoginInfo();
  const [type, seq, msg] = useToast();
  return <ToastPopup type={type} loginInfo={loginInfo} seq={seq} msg={msg} />;
};
